import { QueryClient } from '@tanstack/react-query';
import { LIST_ITEMS_COUNT } from '@/constants/lists.constants';
import { PaginationSearchParams } from '@/api/types';
import { bannedDriversQuery } from '@/queries/banned-drivers';

export const bannedDriversLoader = (queryClient: QueryClient) => () => {
  const params: PaginationSearchParams = {
    itemsPerPage: LIST_ITEMS_COUNT,
    pageIndex: 0,
  };
  return queryClient.ensureQueryData(bannedDriversQuery.list(params));
};

export const bannedDriversByIdLoader = (queryClient: QueryClient) => (bannedDriverId: string) => {
  return queryClient.fetchQuery({
    ...bannedDriversQuery.item(bannedDriverId),
  });
};
